import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { SectionsApi } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { SectionDetailPage } from "./SectionDetailPage";

export interface ISectionItemPageProps {}

export const SectionItemPage: React.FunctionComponent<ISectionItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const api = useApiService(SectionsApi);
  const { currentLanguage } = useGlobalData();
  const [displayName, loading] = useApiEffect(() => api.getDisplayName(+id, currentLanguage.languageCode), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Sections), route: ERoutes.section },
        { text: +id > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsSection"
        onChange={(newTabId) => history.push(`${ERoutes.section}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.section} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<SectionDetailPage sectionId={+id} edit={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
